import { smoothScroll } from "./helpers";

const bookingButton = document.querySelector('.single-room__hero-button')

if (bookingButton) {
  bookingButton.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation();

    if (e.currentTarget.classList.contains('disabled')) return

    smoothScroll(e.currentTarget.getAttribute('href'), 200)
  })
}
